// extracted by mini-css-extract-plugin
module.exports = {"link":"event-card-module--link--zNHH8","card":"event-card-module--card--1Fogv","title":"event-card-module--title--2RcTU","image":"event-card-module--image--3U417"};